import { postRequest } from "apis/ApiInstence";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import indianCities from "../../commonData/indianCities.json"; 

const AddServiceMen = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    city: "",
    aadhaar_number: "",
    aadhaar_image: null,
    image: null,
    password: "",
    service_category: "",
    is_active: "YES",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleCityChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      city: selectedOption ? selectedOption.value : "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }

    try {
      console.log(
        "Form Submitted:",
        Object.fromEntries(formDataToSend.entries())
      );
      const response = await postRequest("/servicemen", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Response:", response);
      toast.success("Service Men added successfully!");
      navigate("/servicemen");
    } catch (error) {
      console.error("Error adding service men:", error.message);
      toast.error("Failed to add service men");
    }
  };

  // Convert JSON city list to react-select format
  const cityOptions = indianCities.map((city) => ({
    value: city,
    label: city,
  }));

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Service Men</h4>
      </div>
      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-5">
          <div className="col-sm-4 mt-2">
            <label htmlFor="fullname" className="lables">
              Full Name
            </label>
            <input
              id="fullname"
              type="text"
              name="name"
              value={formData.name}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-4 mt-2">
            <label htmlFor="mobile" className="lables">
              Mobile
            </label>
            <input
              id="mobile"
              type="text"
              name="mobile"
              value={formData.mobile}
              className="form-control"
              onChange={handleChange}
              maxLength={10}
              minLength={10}
              required
            />
          </div>

          <div className="col-sm-4 mt-2">
            <label htmlFor="email" className="lables">
              Email
            </label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="address" className="lables">
              Address
            </label>
            <input
              id="address"
              type="text"
              name="address"
              value={formData.address}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          {/* ✅ Updated City Select */}
          <div className="col-sm-6 mt-2">
            <label htmlFor="city" className="lables">
              City
            </label>
            <Select
              id="city"
              options={cityOptions}
              onChange={handleCityChange}
              value={cityOptions.find(
                (option) => option.value === formData.city
              )}
              placeholder="Select or type city..."
              isClearable
              isSearchable
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="service_category" className="lables">
              Service Category
            </label>
            <input
              id="service_category"
              type="text"
              name="service_category"
              value={formData.service_category}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="aadhaar_number" className="lables">
              Aadhaar Number
            </label>
            <input
              id="aadhaar_number"
              type="text"
              name="aadhaar_number"
              value={formData.aadhaar_number}
              className="form-control"
              onChange={handleChange}
              maxLength={12}
              minLength={12}
              required
            />
          </div>

          <div className="col-sm-6 mt-4">
            <label htmlFor="aadhaar_image" className="lables">
              Aadhaar Image
            </label>
            <input
              id="aadhaar_image"
              type="file"
              name="aadhaar_image"
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-4">
            <label htmlFor="user_image" className="lables">
              User Image
            </label>
            <input
              id="user_image"
              type="file"
              name="image"
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="password" className="lables">
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="is_active" className="lables">
              Is Active
            </label>
            <select
              id="is_active"
              name="is_active"
              value={formData.is_active}
              className="form-control"
              onChange={handleChange}
              required
            >
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button className="btn btn-lg addbtn">Add Service Man</button>
        </div>
      </form>
    </div>
  );
};

export default AddServiceMen;
